import { gql } from "apollo-boost"

export const DELETE_MINISTRATION_PERIOD = gql`
  mutation deleteMinistrationPeriodById($ministrationPeriodId: ID!) {
    DeleteMinistrationPeriodById(ministrationPeriodId: $ministrationPeriodId)
  }
`